export default (paymentValidUntil: string | null): boolean => {
  // If there's no validUntil date, payment is always allowed
  if (paymentValidUntil === null) {
    return true
  }

  // Parse the validUntil date
  const validUntilDate = new Date(paymentValidUntil)
  if (validUntilDate.toString() === "Invalid Date") {
    return false
  }

  // Create "payable from" date (September 1st of the same year as validUntil) using UTC
  const payableFromDate = new Date(Date.UTC(
    validUntilDate.getUTCFullYear(),
    8, // September (0-indexed)
    1  // 1st day
  ))

  // Compare with current date in UTC
  // For testing use:
  // const currentDate = new Date(Date.UTC(2025, 8, 1))
  const currentDate = new Date()
  const currentDateUTC = new Date(Date.UTC(
    currentDate.getUTCFullYear(),
    currentDate.getUTCMonth(),
    currentDate.getUTCDate()
  ))

  // Return true if current date is at or after the "payable from" date
  return currentDateUTC >= payableFromDate
}
